import type { PublicContactSettings } from './schema';

export const CONTACT_SETTINGS_FALLBACK: PublicContactSettings = {
  companyName: 'Glanz CRM',
  supportEmail: 'support@glanzcrm.com',
  salesEmail: 'sales@glanzcrm.com',
  phonePrimary: '+66 954848748',
  phoneWhatsapp: null,
  lineId: null,
  addressLine1: '',
  addressLine2: null,
  city: 'Bangkok',
  country: 'Thailand',
  mapEmbedUrl: null,
  officeHours: [
    { day: 'Monday', openTime: '09:00', closeTime: '18:00', isClosed: false },
    { day: 'Tuesday', openTime: '09:00', closeTime: '18:00', isClosed: false },
    { day: 'Wednesday', openTime: '09:00', closeTime: '18:00', isClosed: false },
    { day: 'Thursday', openTime: '09:00', closeTime: '18:00', isClosed: false },
    { day: 'Friday', openTime: '09:00', closeTime: '18:00', isClosed: false },
    { day: 'Saturday', openTime: '10:00', closeTime: '14:00', isClosed: false },
    { day: 'Sunday', openTime: '', closeTime: '', isClosed: true },
  ],
  timezoneLabel: 'ICT',
  responseTimeNote: 'We respond within 24 hours.',
  urgentContactNote: 'For urgent matters call +66 954848748',
  socialLinks: {},
  demoBookingUrl: '/demo',
  pricingUrl: '/pricing',
  loginUrl: '/auth',
  isActive: true,
  updatedByName: null,
  updatedAt: undefined,
};
